import omit from 'lodash.omit'

import { createSelector } from 'reselect'
import { isNifRequiredAndMissingSelector, userSelector, deliveryAddressSelector } from 'auth/selectors'
import { pendingSelector } from 'api/selectors'

import { searchModeSelector } from 'map/selectors'
import { SEARCH_MODE_MONTHLY } from 'search/constants'

export const basketSelector = state => state.basket

export const creditCardsSelector = createSelector(userSelector, user => (user ? user.creditCards : []))

export const totalSelector = createSelector(basketSelector, basket =>
    basket.items
        .map(({ rate: { amount }, promoCode }) => (promoCode ? promoCode.discountTotal : amount))
        .reduce((a, b) => a + b, 0)
)

export const makePurchasePendingSelector = createSelector(pendingSelector, pending => pending.makePurchase)

export const extendReservationPendingSelector = createSelector(pendingSelector, pending => pending.extendReservation)

export const addressIsSetSelector = createSelector(deliveryAddressSelector, userSelector, (address, user) => {
    const excludedFields = ['address2', 'firstName', 'lastName']

    if (user && user.details.excludeFields.includes('ACCOUNTSTATE')) {
        excludedFields.push('state')
    }

    return (
        Object.keys(omit(address, excludedFields))
            .map(key => address[key].trim())
            .indexOf('') === -1
    )
})

export const addressToStringSelector = createSelector(deliveryAddressSelector, address => {
    const addressFields = Object.keys(omit(address, ['firstName', 'lastName']))
    return (
        addressFields.length !== 0 &&
        addressFields
            .map(key => address[key].trim())
            .filter(field => field !== '')
            .join(', ')
    ) // TODO: should sort before join?
})

export const hasMonthlyPassSelector = createSelector(
    basketSelector,
    basket => basket.items.filter(item => item.rate.isMonthlyPass === true).length > 0
)

export const isEmptySelector = createSelector(basketSelector, basket => basket.items.length === 0)
export const numberOfItemsSelector = createSelector(basketSelector, basket => basket.items.length)

export const locationIdSelector = createSelector(basketSelector, basket => {
    if (basket.items.length > 0 && basket.items[0].rate) return basket.items[0].rate.eDataLocationId
    return ''
})

export const lastItemLocationIdSelector = createSelector(basketSelector, basket => {
    if (basket.items.length > 0 && basket.items[basket.items.length - 1].rate)
        return basket.items[basket.items.length - 1].rate.eDataLocationId
    return ''
})
export const addAnotherBookingUrlSelector = createSelector(
    lastItemLocationIdSelector,
    searchModeSelector,
    (lastItemLocationId, searchMode) => {
        if (lastItemLocationId) {
            return searchMode === SEARCH_MODE_MONTHLY
                ? `/booking/${lastItemLocationId}/subscriptions`
                : `/booking/${lastItemLocationId}`
        }
        return null
    }
)

export const allowPurchaseSingleTicketSelector = createSelector(
    addressIsSetSelector,
    hasMonthlyPassSelector,
    makePurchasePendingSelector,
    isNifRequiredAndMissingSelector,
    (addressIsSet, hasMonthlyPass, makePurchasePending, isNifRequiredAndMissing) =>
        makePurchasePending !== true && (hasMonthlyPass ? addressIsSet : true) && !isNifRequiredAndMissing
)

export const allowPurchaseSelector = createSelector(
    isEmptySelector,
    allowPurchaseSingleTicketSelector,
    (isEmpty, allowPurchase) => !isEmpty && allowPurchase
)

export const purchaseCompletedSelector = createSelector(basketSelector, basket => basket.purchaseCompleted)
